exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".precios-bubble:before {\n  color: #D80000;\n  content: ' \\25CF';\n  font-size: 1.3rem;\n  position: absolute;\n  right: 17px;\n  top: 7px;\n  z-index: 10; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios-header/precios-header.component.scss
// module id = ../../../../../src/app/components/precios-seccion/precios-header/precios-header.component.scss
// module chunks = 0